import { __assign, __extends, __makeTemplateObject, __rest } from "tslib";
import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { css } from '@emotion/core';
import { color, shadow, border } from '@metro-ui/tokens/js';
import { rgba } from '../../utils/rgba';
import { OutsideClick } from '../../utils/OutsideClick';
import { Layout } from '../../Layout';
import { SidebarContext } from './SidebarContext';
import { slideInAnimation } from './SidebarAnimations';
var Background = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ", ";\n"], ["\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: ", ";\n"])), color.contrast.white);
export var SidebarSubMenu = styled(/** @class */ (function (_super) {
    __extends(SidebarSubMenu, _super);
    function SidebarSubMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { activeIndex: 0 };
        _this.activeRef = React.createRef();
        _this.onKeyDown = function (e) {
            var activeIndex = _this.state.activeIndex;
            var _a = _this.props, children = _a.children, onKeyDown = _a.onKeyDown;
            var length = React.Children.count(children);
            switch (e.key) {
                case 'ArrowDown':
                case 'Down':
                    _this.setState({ activeIndex: (activeIndex + 1) % length });
                    e.stopPropagation();
                    break;
                case 'ArrowUp':
                case 'Up':
                    _this.setState({ activeIndex: (activeIndex - 1 + length) % length });
                    e.stopPropagation();
                    break;
                default:
            }
            if (onKeyDown)
                onKeyDown(e);
        };
        _this.renderSubMenu = function (ref) {
            var _a = _this.props, level = _a.level, label = _a.label, onCloseSubMenu = _a.onCloseSubMenu, className = _a.className, children = _a.children, htmlAttributes = __rest(_a, ["level", "label", "onCloseSubMenu", "className", "children"]);
            var activeIndex = _this.state.activeIndex;
            return (React.createElement(SidebarContext.Consumer, null, function (_a) {
                var isExpanded = _a.isExpanded;
                return (React.createElement(Layout, __assign({}, htmlAttributes, { onKeyDown: _this.onKeyDown, role: "menu", "aria-orientation": "vertical", "aria-label": label, direction: "column", className: className, "data-is-expanded": isExpanded, ref: ref }),
                    React.createElement(Background, null),
                    React.Children.map(children, function (child, index) {
                        if (index === activeIndex) {
                            var element = child;
                            if (React.isValidElement(element)) {
                                element = React.cloneElement(element, {
                                    ref: _this.activeRef,
                                });
                            }
                            return element;
                        }
                        return child;
                    })));
            }));
        };
        return _this;
    }
    SidebarSubMenu.prototype.componentDidMount = function () {
        if (this.activeRef && this.activeRef.current) {
            this.activeRef.current.focus();
        }
    };
    SidebarSubMenu.prototype.componentDidUpdate = function (_, prevState) {
        var activeIndex = this.state.activeIndex;
        if (prevState.activeIndex !== activeIndex &&
            this.activeRef &&
            this.activeRef.current) {
            this.activeRef.current.focus();
        }
    };
    SidebarSubMenu.prototype.render = function () {
        var _this = this;
        var onCloseSubMenu = this.props.onCloseSubMenu;
        return onCloseSubMenu ? (React.createElement(OutsideClick, { onOutsideClick: onCloseSubMenu }, function (_a) {
            var outsideClickRef = _a.outsideClickRef;
            return _this.renderSubMenu(outsideClickRef);
        })) : (this.renderSubMenu());
    };
    return SidebarSubMenu;
}(React.Component)))(function (_a) {
    var _b = _a.level, level = _b === void 0 ? 2 : _b;
    return css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 5rem;\n    width: calc(18.5rem - ", ");\n    z-index: -1;\n    background-color: ", ";\n    box-shadow: ", " ", ";\n    border-right: ", " solid ", ";\n    transition: left 0.2s ease-in-out;\n\n    &[data-is-expanded='true'] {\n      left: 21.75rem;\n    }\n\n    ", "\n\n    ", "\n  "], ["\n    position: fixed;\n    top: 0;\n    bottom: 0;\n    left: 5rem;\n    width: calc(18.5rem - ", ");\n    z-index: -1;\n    background-color: ", ";\n    box-shadow: ", " ", ";\n    border-right: ", " solid ", ";\n    transition: left 0.2s ease-in-out;\n\n    &[data-is-expanded='true'] {\n      left: 21.75rem;\n    }\n\n    ", "\n\n    ", "\n  "])), border.width.thin, color.contrast.white, shadow.medium.default, rgba(shadow.color, shadow.alpha), border.width.thin, color.palette.grey.tint[90], level > 2 && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      left: ", "rem;\n\n      &[data-is-expanded='true'] {\n        left: ", "rem;\n      }\n    "], ["\n      left: ", "rem;\n\n      &[data-is-expanded='true'] {\n        left: ", "rem;\n      }\n    "])), (level - 2) * 18.5 + 5, (level - 2) * 18.5 + 21.75), slideInAnimation);
});
SidebarSubMenu.propTypes = {
    level: PropTypes.number,
    label: PropTypes.string,
    onCloseSubMenu: PropTypes.func,
    className: PropTypes.string,
    children: PropTypes.node,
};
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=SidebarSubMenu.js.map